var translation = {
	Navatar: {
		header: "Profil AWS",
		subheader: "Votre profil vous aide à améliorer vos interactions avec certaines expériences AWS.",
		profileButtonText: "Voir le profil",
		logOutText: "Se déconnecter",
		logInText: "Se connecter",
		createProfileText: "Créer un profil",
		federateLoginModalTitle: "Utiliser Midway pour accéder à votre profil AWS",
		federateLoginModalFirstDescription: "En tant qu’employé d’Amazon, nous vous recommandons d’utiliser Midway pour accéder à votre profil AWS. Cette méthode recommandée en matière de sécurité offre une intégration parfaite avec les systèmes internes.",
		federateLoginModalSecondDescription: "Ce message s’affiche parce que vous vous êtes connecté avec une adresse e-mail Amazon à l’aide de l’ID de créateur AWS. Cette invite apparaît chaque fois que vous vous connectez jusqu’à ce que vous passiez à Midway ou que vous choisissiez de continuer avec votre connexion actuelle.",
		federateLoginModalPrimaryButton: "Se connecter avec Midway",
		federateLoginModalSecondaryButton: "Continuer avec l’ID de créateur AWS"
	}
};
var Navatar = {
	translation: translation
};

export { Navatar as default, translation };
